import React, { useEffect, useState } from 'react'
import { useOrderStore } from 'src/hooks/order';
import System from 'src/helper/system';
import { useObjCommonFilterStore } from 'src/hooks/objCommonFilter';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';

const OrderHistoryHeader = () => {
    const [{ order_list, order_export_count, orderParams }, { }, { export_email }] = useOrderStore();
    const [pageLoader, setPageLoader] = useState(false);
    const [{ filter_list }, { }, { }] = useObjCommonFilterStore();
    const [disable, setDisable] = useState({ emailFiltered: false, emailAll: false });

    useEffect(() => {
        sessionStorage.removeItem(System.storageName.SUCCESS_PAGE)
    }, []);

    useEffect(() => {
        const isOrderListEmpty = order_list && order_list.totalOrderList === 0;

        if (isOrderListEmpty) {
            setDisable({
                emailFiltered: order_export_count > 0 && order_list?.orderList?.length > 0 ? false : true,
                emailAll: order_export_count > 0 ? false : true
            });
        } else {
            setDisable({ emailFiltered: false, emailAll: false });
        }
    }, [order_list, filter_list, order_export_count]);

    const exportAllOrder = async () => {
        closeDropdown();
        setPageLoader(true);
        let result = await export_email({
            "filterByOption": [],
            "sortBy": orderParams.sortBy,
            "sortOrder": orderParams.sortOrder,
        });
        if (result) {
            setPageLoader(false);
            System.popup('ThankYouPopup', { isOrderHistory: true }); // open pop-up before API Call    
        }
    }

    const exportFilterOrder = async () => {
        closeDropdown();
        let result = await export_email({
            "keyword": orderParams.keyword,
            "searchType": orderParams.searchType,
            "filterByOption": orderParams.filterByOption,
            "sortBy": orderParams.sortBy,
            "sortOrder": orderParams.sortOrder,
        });
        if (result) {
            setPageLoader(false);
            System.popup('ThankYouPopup', { isOrderHistory: true }); // open pop-up before API Call    
        }
    }

    const closeDropdown = () => {
        let _dropdownElem = document.getElementById('emailFilter');
        if (_dropdownElem !== undefined && _dropdownElem.classList.contains('open')) {
            _dropdownElem.removeAttribute('class');
            _dropdownElem.setAttribute('class', 'dropdown ms-4')
        }
    }

    return (
        <>
            <div className="pcn-page-head header-container d-flex align-items-center justify-sm-content-between flex-wrap flex-sm-nowrap">
                <div className="page-title font-oswald font-light font-30 mb-3 mb-sm-0">Order History</div>
                <div className="ms-sm-auto mb-0">
                    <ul className="d-flex justify-content-start justify-content-lg-end list-unstyled mb-0 order-history-top">
                        <span className='order-history-header'>
                            <div className="ms-4">
                                {pageLoader && <AxiosIndicatorRunTimeLoader />}
                            </div>
                            {pageLoader === false &&
                                <li id="emailFilter" className="dropdown ms-4">
                                    <a href={void (0)} data-toggle="dropdown" aria-expanded="false"><i className="fa fa-envelope me-2 text-black" aria-hidden="true"></i> Email Orders</a>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><a className={disable.emailAll ? "dropdown-item link-disabled" : "dropdown-item"} href={void (0)}
                                            onClick={() => exportAllOrder()}>Email All</a></li>
                                        <li><a className={disable.emailFiltered ? "dropdown-item link-disabled" : "dropdown-item"} href={void (0)}
                                            onClick={() => exportFilterOrder()}>Email Filtered</a></li>
                                    </ul>
                                </li>
                            }
                        </span>

                        <li className="ms-4">
                            <a href={void (0)} onClick={() => window.print()}>
                                <i className="fa fa-print me-2 text-black"></i>Print Page</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="pcn-line-divider mb-0" />
        </>
    )
}

export default OrderHistoryHeader